import script from "./CardFormSpawnPoint.vue?vue&type=script&lang=js"
export * from "./CardFormSpawnPoint.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__